import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _inherits from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _setPrototypeOf from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/setPrototypeOf.js";
import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _taggedTemplateLiteral from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(re, groups) { return new BabelRegExp(re, void 0, groups); }; var _super = RegExp.prototype, _groups = new WeakMap(); function BabelRegExp(re, flags, groups) { var _this = new RegExp(re, flags); return _groups.set(_this, groups || _groups.get(re)), _setPrototypeOf(_this, BabelRegExp.prototype); } function buildGroups(result, re) { var g = _groups.get(re); return Object.keys(g).reduce(function (groups, name) { return groups[name] = result[g[name]], groups; }, Object.create(null)); } return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (str) { var result = _super.exec.call(this, str); return result && (result.groups = buildGroups(result, this)), result; }, BabelRegExp.prototype[Symbol.replace] = function (str, substitution) { if ("string" == typeof substitution) { var groups = _groups.get(this); return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) { return "$" + groups[name]; })); } if ("function" == typeof substitution) { var _this = this; return _super[Symbol.replace].call(this, str, function () { var args = arguments; return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args); }); } return _super[Symbol.replace].call(this, str, substitution); }, _wrapRegExp.apply(this, arguments); }

import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { gql } from "@apollo/client";
import { metaResolveType, createPageInfo } from "./helper";
export var typeDef = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  type TrackResult {\n    result: Boolean\n  }\n\n  union RecommendMeta = EpisodeMeta | LiveMeta | TVShowMeta\n\n  type RecommendConnection @cacheControl(scope: PRIVATE, maxAge: 0) {\n    elementId: String\n    data: [RecommendMeta]\n    pageInfo: PageInfo\n  }\n\n  type Mutation {\n    track(location: String!, referrer: String, sid: String): TrackResult\n  }\n\n  type Query {\n    recommend(location: String!, elementIds: [String!]): [RecommendConnection]\n  }\n"])));
export var resolvers = {
  Mutation: {
    track: function () {
      var _track = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_parent, _ref, _ref2) {
        var location, referrer, sid, req, dataSources, options;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                location = _ref.location, referrer = _ref.referrer, sid = _ref.sid;
                req = _ref2.req, dataSources = _ref2.dataSources;
                _context.prev = 2;

                if (req.adultMode) {
                  _context.next = 7;
                  break;
                }

                options = function () {
                  if (sid) {
                    return {
                      "_rt.sid": sid
                    };
                  }

                  return null;
                }();

                _context.next = 7;
                return dataSources.rtoaster.track(location, referrer, options);

              case 7:
                return _context.abrupt("return", {
                  result: true
                });

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](2);
                console.log(_context.t0);
                return _context.abrupt("return", {
                  result: false
                });

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 10]]);
      }));

      function track(_x, _x2, _x3) {
        return _track.apply(this, arguments);
      }

      return track;
    }()
  },
  Query: {
    recommend: function () {
      var _recommend = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_parent, _ref3, _ref4) {
        var location, elementIds, req, dataSources, response, result, promises;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                location = _ref3.location, elementIds = _ref3.elementIds;
                req = _ref4.req, dataSources = _ref4.dataSources;
                _context3.prev = 2;

                if (req.adultMode) {
                  _context3.next = 13;
                  break;
                }

                _context3.next = 6;
                return dataSources.rtoaster.recommend(location, elementIds);

              case 6:
                response = _context3.sent;

                if (!(response !== null && response !== void 0 && response.result)) {
                  _context3.next = 13;
                  break;
                }

                result = response.result.map(function (v) {
                  // こう言う形で入ってくるので加工する
                  // {
                  //   attributes: {
                  //     elementId: 'rt_detail_user_auto_10',
                  //     sessionId: 'P38ddfa39298f7f70001174e0000001400000000412c302a'
                  //   },
                  //   '$value': '<div>63988</div>'
                  // }
                  var elementId = elementIds.find(function (elId) {
                    return !!~v.attributes.elementId.indexOf(elId);
                  });
                  var matched = v["$value"].match( /*#__PURE__*/_wrapRegExp(/(\d+)/, {
                    id: 1
                  }));
                  var value = Number(matched.groups.id);
                  return {
                    elementId: elementId,
                    rtsid: v.attributes.sessionId,
                    id: value
                  };
                }).reduce(function (acc, v) {
                  // elementIdごとにまとめる
                  if (!acc[v.elementId]) {
                    acc[v.elementId] = [];
                  }

                  acc[v.elementId].push({
                    id: v.id,
                    rtsid: v.rtsid
                  });
                  return acc;
                }, {});
                promises = Object.keys(result).map( /*#__PURE__*/function () {
                  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(elementId) {
                    var ids, _yield$dataSources$me, metas, metasWithRtsid;

                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            ids = result[elementId].map(function (v) {
                              return v.id;
                            });
                            _context2.next = 3;
                            return dataSources.meta.searchFromId(ids);

                          case 3:
                            _yield$dataSources$me = _context2.sent;
                            metas = _yield$dataSources$me.metas;
                            metasWithRtsid = result[elementId].map(function (_ref6) {
                              var id = _ref6.id,
                                  rtsid = _ref6.rtsid;
                              var meta = metas.find(function (meta) {
                                return meta.id === id;
                              });

                              if (meta) {
                                return _objectSpread(_objectSpread({}, meta), {}, {
                                  rtsid: rtsid
                                });
                              } else {
                                return null;
                              }
                            }).filter(function (x) {
                              return !!x;
                            });
                            return _context2.abrupt("return", {
                              elementId: elementId,
                              data: metasWithRtsid,
                              pageInfo: createPageInfo({
                                offset: 0,
                                limit: metasWithRtsid.length,
                                count: metasWithRtsid.length
                              })
                            });

                          case 7:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x7) {
                    return _ref5.apply(this, arguments);
                  };
                }());
                _context3.next = 12;
                return Promise.all(promises);

              case 12:
                return _context3.abrupt("return", _context3.sent);

              case 13:
                _context3.next = 18;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3["catch"](2);
                console.log("rtoaster recommend error", _context3.t0);

              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[2, 15]]);
      }));

      function recommend(_x4, _x5, _x6) {
        return _recommend.apply(this, arguments);
      }

      return recommend;
    }()
  },
  RecommendMeta: {
    __resolveType: metaResolveType
  }
};